/* eslint-disable */
/* GENERATED BY DECAFFEINATE */

// This file contains all keybindings. No bindings should include multiple keys
// i.e. ['left', 'right']. They should be split out in to individual bindings to
// prevent overwriting. For common functionality, define functions and call them
// in each key.

Mousetrap.bind("escape", function() {
	// Close modal, do nothing else
	if (
		typeof Modal !== "undefined" && Modal !== null
			? Modal.hasActive()
			: undefined
	) {
		Modal.close();
		return;
	}

	// Close OkPhotos, do nothing else
	if (
		typeof OkPhotos !== "undefined" && OkPhotos !== null
			? OkPhotos.isOpen()
			: undefined
	) {
		OkPhotos.close();
		return;
	}

	// Close profile panel, do nothing else
	if (
		typeof ProfilePanel !== "undefined" && ProfilePanel !== null
			? ProfilePanel.isOpen()
			: undefined
	) {
		ProfilePanel.close();
		return;
	}

	if (
		typeof OkModalManager !== "undefined" && OkModalManager !== null
			? OkModalManager.closeAll()
			: undefined
	) {
		OkModalManager.closeAll();
		return;
	}
});

Mousetrap.bind("up", function() {
	// Previous photo
	if (
		typeof PhotoOverlay !== "undefined" && PhotoOverlay !== null
			? PhotoOverlay.isOpen()
			: undefined
	) {
		PhotoOverlay.previous();
		return;
	}
});

Mousetrap.bind("down", function() {
	// Next photo
	if (
		typeof PhotoOverlay !== "undefined" && PhotoOverlay !== null
			? PhotoOverlay.isOpen()
			: undefined
	) {
		PhotoOverlay.next();
		return;
	}
});

Mousetrap.bind("left", function() {
	// Previous photo
	if (
		typeof PhotoOverlay !== "undefined" && PhotoOverlay !== null
			? PhotoOverlay.isOpen()
			: undefined
	) {
		PhotoOverlay.previous();
		return;
	}
});

Mousetrap.bind("right", function() {
	// Next photo
	if (
		typeof PhotoOverlay !== "undefined" && PhotoOverlay !== null
			? PhotoOverlay.isOpen()
			: undefined
	) {
		PhotoOverlay.next();
		return;
	}
});

Mousetrap.bind(",", function() {
	// Previous photo
	if (
		typeof PhotoOverlay !== "undefined" && PhotoOverlay !== null
			? PhotoOverlay.isOpen()
			: undefined
	) {
		PhotoOverlay.previous();
	}
});

Mousetrap.bind(".", function() {
	// Next photo
	if (
		typeof PhotoOverlay !== "undefined" && PhotoOverlay !== null
			? PhotoOverlay.isOpen()
			: undefined
	) {
		PhotoOverlay.next();
	}
});



// WEBPACK FOOTER //
// ./src/legacy/keybindings.js